<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col>
                            <list-report-head :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                                {{ $t('assitive_device_management.fund_receive_info_details') }}
                            </list-report-head>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <div style="font-size: 16px; background-color: #44B2D8;"><h5 class="text-white text-center">{{$t('assitive_device_management.fund_recieved_info')}}</h5></div>
                                    <b-table-simple striped bordered small hover class="mb-5">
                                       <tbody>
                                            <b-tr>
                                                <b-td style="width: 50% !important;">{{$t('assitive_device_management.memo_no')}}</b-td>
                                                <b-td style="width: 50% !important;">{{$n(data.memo_no, { useGrouping: false })}}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('globalTrans.fiscal_year')}}</b-td>
                                                <b-td style="width: 50% !important;">{{ ($i18n.locale === 'bn') ? data.fiscalYearName_bn : data.fiscalYearName_en}}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('assitive_device_management.fund_recieved_date')}}</b-td>
                                                <b-td>{{data.fund_recieved_date|dateFormat}}</b-td>
                                            </b-tr>
                                       </tbody>
                                    </b-table-simple>
                                    <b-row class="mb-4 mt-2" style="border: 1px solid black;padding-top: 23px;padding-bottom: 27px;}">
                                    <table class="m-auto mb-4">
                                        <thead style="background-color: #44B2D8;">
                                        <tr>
                                            <th>{{$t('globalTrans.sl_no')}}</th>
                                            <th>{{ $t('assitive_device_management.assistive_device_name')}}</th>
                                            <th>{{ $t('assitive_device_management.requisition_quantity')}}</th>
                                            <th>{{ $t('assitive_device_management.funding_quantity')}}</th>
                                            <th>{{ $t('assitive_device_management.unit_price')}}</th>
                                            <th>{{ $t('assitive_device_management.total_tk')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in AddmoreArray" :key="index" >
                                            <td style="color:black;">{{$n(index + 1)}}</td>
                                            <td style="color:black;">{{$i18n.locale === 'bn' ? item.assistiveDeviceName_bn : item.assistiveDeviceName_en}}</td>
                                            <td class="text-right" style="color:black;">{{$n(item.requisition_quantity)}}</td>
                                            <td class="text-right" style="color:black;">{{$n(item.funding_quantity)}}</td>
                                            <td class="text-right" style="color:black;">{{$n(item.unit_price)}}</td>
                                            <td class="text-right" style="color:black;">{{$n(item.total_price)}}</td>
                                        </tr>
                                    </tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-th colspan="2" class="text-right">{{ $t('sitePreference.grandTotal') }}</b-th>
                                            <b-th class="text-right">{{ $n(grandTotalInfo.requisition_quantity) }}</b-th>
                                            <b-th class="text-right">{{ $n(grandTotalInfo.funding_quantity) }}</b-th>
                                            <b-th></b-th>
                                            <b-th class="text-right">{{ $n(grandTotalInfo.total_price) }}</b-th>
                                        </b-tr>
                                    </b-tfoot>
                                    </table>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import RestApi, { disabilitySchoolServiceBaseUrl, awarenessEventServiceBaseUrl } from '@/config/api_config'
import { ResourceManagementStoreApi, ResourceManagementUpdateApi } from '../../api/routes'
import ExportPdf from './export-pdf_details'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'

export default {
    name: 'FormLayout',
    props: ['id', 'item', 'resourceDetails'],
    components: {
        ListReportHead
    },
    created () {
      if (this.id) {
          const store = this.$store
          this.item.details.map(function (ele) {
            try {
            ele.assistiveDeviceName_en = store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === ele.assistive_device_id).text_en
            ele.assistiveDeviceName_bn = store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === ele.assistive_device_id).text_bn
            } catch (e) {
            }
          })
          this.AddmoreArray.push(...this.item.details)
          this.predata = this.getData()
          this.data.fiscal_year_id = this.predata.fiscal_year_id
          this.data.fiscalyear = this.predata.fiscalyear
          this.data.memo_no = this.predata.memo_no
          this.data.fund_recieved_date = this.predata.fund_recieved_date
          this.data.fiscalYearName_en = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.data.fiscal_year_id).text_en
          this.data.fiscalYearName_bn = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.data.fiscal_year_id).text_bn
      }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            ItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            predata: null,
            loading: false,
            data: {
                memo_no: '',
                fiscalyear: '',
                fiscalYearName_en: '',
                fiscalYearName_bn: '',
                fiscal_year_id: '',
                fund_recieved_date: '',
                AddmoreArrayO: []
            },
            validationArray: [],
            addmorelist:
             {
                resource_name_en: '',
                resource_name_bn: '',
                quantity: ''
            },
            awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
            AddmoreArray: [],
            grandTotalInfo: {
                requisition_quantity: 0,
                funding_quantity: 0,
                total_price: 0
            }
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYear: function () {
            const objectData = this.$store.state.commonObj.fiscalYearList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
    'data.organization': function (newVal) {
      this.officeTypeList = this.getofficeTypeList(newVal)
    },
    'data.institute_type': function (newVal) {
      this.officeList = this.getOfficeList(newVal)
    }
    },
    methods: {
        pdfExport () {
            const reportTitle = this.$t('assitive_device_management.fund_receive_info_details')
            ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.item, this, this.grandTotalInfo)
        },
        addItem () {
            const obj = {
                resource_name_en: this.addmorelist.resource_name_en,
                resource_name_bn: this.addmorelist.resource_name_bn,
                quantity: this.addmorelist.quantity
            }
            this.validationArray.push(obj)
            const validation = this.validationArray.every(item => item.resource_name_en && item.resource_name_bn && item.quantity)
            if (validation === false) {
            this.$toast.success({
                    title: 'Error',
                    message: 'Please Fill all three fields',
                    color: '#a61927'
            })
            } else {
            this.AddmoreArray.push(obj)
            this.addmorelist = []
            }
        },
        delItem (index) {
         this.AddmoreArray.splice(index, 1)
        },
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        },
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            this.data.AddmoreArrayO = []
            this.data.AddmoreArrayO = this.AddmoreArray
            if (this.id) {
                result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${ResourceManagementUpdateApi}/${this.id}`, this.data)
            } else {
                result = await RestApi.postData(disabilitySchoolServiceBaseUrl, ResourceManagementStoreApi, this.data)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loading = false
                this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            this.getGrandTotalInfo()
            return JSON.parse(JSON.stringify(tmpData))
        },
        getGrandTotalInfo () {
           let totalRequistionQuantity = 0
           let totalFundingQuantity = 0
           let totalPrice = 0
            this.AddmoreArray.forEach(item => {
                totalRequistionQuantity += parseInt(item.requisition_quantity)
                totalFundingQuantity += parseInt(item.funding_quantity)
                totalPrice += parseFloat(item.total_price)
            })
            this.grandTotalInfo = Object.assign({}, this.grandTotalInfo, {
               requisition_quantity: totalRequistionQuantity,
               funding_quantity: totalFundingQuantity,
               total_price: totalPrice
            })
        }
    }
}
</script>

<style>
body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

table, th, td {
  border: solid 1px #000;
  padding: 10px;
  color: black;
}

table {
    border-collapse:collapse;
    caption-side:bottom;
}

caption {
  font-size: 16px;
  font-weight: bold;
  padding-top: 5px;
}
.toast-title {
  color:white;
}
.toast-message {
    color:white;
}
</style>
